<div class="skeleton-container">
  @for (i of items; track i) {
  <div class="skeleton-product-item">
    <ion-skeleton-text animated class="skeleton-product-icon" />
    <div class="skeleton-product-info">
      <ion-skeleton-text animated class="skeleton-product-name" />
      <ion-skeleton-text animated class="skeleton-product-price" />
    </div>
  </div>
  }
</div>
